/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@dm/core';

import { CreateFileSystemModule } from '../../../file-system/create-file-system/create-file-system.module';
import { FrontTableClientCifsShareModule } from '../client-cifs-share/front-table-client-cifs-share/front-table-client-cifs-share.module';
import { FrontTableHomedirRuleCifsShareModule } from '../homedir-rule-cifs-share/front-table-homedir-rule-cifs-share/front-table-homedir-rule-cifs-share.module';
import { CreateCifsHomedirComponent } from './create-cifs-homedir.component';

@NgModule({
    declarations: [CreateCifsHomedirComponent],
    exports: [CreateCifsHomedirComponent],
    imports: [
        CommonModule,
        CoreModule,
        ReactiveFormsModule,
        FormsModule,
        FrontTableClientCifsShareModule,
        CreateFileSystemModule,
        FrontTableHomedirRuleCifsShareModule,
    ],
})
export class CreateCifsHomedirModule { }
